module.exports = __webpack_public_path__ + "img/items-grid-03.ee6a9508.png";